import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducers from './modules';
import { defaultState } from './modules/map';

export default (props) => {
  const store = createStore(
    reducers,
    { map: defaultState(props) },
    composeWithDevTools({})(applyMiddleware(thunk)),
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/store.js